module.exports = __webpack_public_path__ + "static/media/stedelijk.575c3290.jpg";